exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unassigned-opener {\n    opacity: 0.6;\n    font-style: italic;\n}\n.opener_name {\n    text-align: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/leads/import-list/style.css
// module id = 1221
// module chunks = 9